export const EMPTY_NOTES_STRING =
  "Add comments and suggestions as notes here. Invite your teammates and have threaded conversations with collaborators.";

export const OPEN_NOTES_ERROR =
  "Please save or discard the existing note before adding a new note.";



// WEBPACK FOOTER //
// ./src/stringConstants/notes.js